<template>
    <div>
      <!-- modal -->
      <b-modal
        id="invoicePdfFormModal"
        centered
        size="lg"
        no-close-on-backdrop
        ref="invoicePdfFormModal"
        :title=" $t('invoicePdf.info')"
        hide-footer
      >
        <validation-observer ref="simpleRules">
          <b-form>
            <label for="invoice-pdf-name-input">{{ $t('invoicePdf.name') }}</label>
            <b-form-group>
            <validation-provider
              #default="{ errors }"
              :name=" $t('invoicePdf.name')"
              rules="required"
            >
            <b-form-input
              size="sm"
              id="invoice-pdf-name-input"
              v-model="name"
              maxlength="50"
              :state="errors.length > 0 ? false:null"
            />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          </b-form>
      </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        id: 0,
        name: '',
      }
    },
    methods: {
      showInfo(id) {  
        this.$refs['invoicePdfFormModal'].show()
        this.id = id
        const data = {id: this.id}
        const controller = {name : 'Department'}
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
            if(response.data.resultStatus == true){
                this.departmentName = response.data.department.name
            } else {
                this.$bvModal.hide('invoicePdfFormModal')
                this.$WarningAlert(response.data.resultMessage)
            }  
        })  
      },
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  </style>
  